export const downloadCSVSample = (filename, headers, sampleData = []) => {
    const rows = [headers, ...sampleData];
    const csvContent = rows
        .map(row => row.map(field => `"${field}"`).join(','))
        .join('\r\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};